import React, { useMemo, useState } from 'react';

const AnalyticsOpponents = ({ allGames }) => {
  const [sort, setSort] = useState('winPct');

  const opponents = useMemo(() => {
    if (!allGames?.length) return [];
    const finished = allGames.filter(g => g.status?.abstractGameState === 'Final');
    const oppMap = {};

    finished.forEach(g => {
      const bosHome = g.teams?.home?.team?.id === 111;
      const opp = bosHome ? g.teams.away.team : g.teams.home.team;
      const bosScore = Number(bosHome ? g.teams.home.score : g.teams.away.score);
      const oppScore = Number(bosHome ? g.teams.away.score : g.teams.home.score);
      const won = bosScore > oppScore;
      const key = opp.id;

      if (!oppMap[key]) oppMap[key] = { name: opp.name, abbr: opp.abbreviation, w: 0, l: 0, rs: 0, ra: 0 };
      oppMap[key].rs += bosScore;
      oppMap[key].ra += oppScore;
      if (won) oppMap[key].w++;
      else oppMap[key].l++;
    });

    return Object.values(oppMap).map(o => ({
      ...o,
      games: o.w + o.l,
      winPct: o.w + o.l > 0 ? o.w / (o.w + o.l) : 0,
      rd: o.rs - o.ra,
      rpg: o.w + o.l > 0 ? (o.rs / (o.w + o.l)).toFixed(2) : '0.00',
    })).sort((a, b) => {
      if (sort === 'winPct') return b.winPct - a.winPct;
      if (sort === 'games') return b.games - a.games;
      if (sort === 'rd') return b.rd - a.rd;
      return 0;
    });
  }, [allGames, sort]);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-1.5 flex-wrap">
        {[['winPct', 'Win %'], ['games', 'Games'], ['rd', 'Run Diff']].map(([key, label]) => (
          <button key={key} onClick={() => setSort(key)}
            className={`text-[9px] font-bold uppercase tracking-widest px-2.5 py-1 border transition-colors ${sort === key ? 'bg-[#658d71] border-[#a9c9b1] text-white' : 'border-[#658d71] text-[#a9c9b1] hover:text-white'}`}>
            {label}
          </button>
        ))}
      </div>

      <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)] overflow-x-auto">
        <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
          <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Record vs Each Opponent</span>
        </div>
        <table className="w-full text-center" style={{ minWidth: '420px' }}>
          <thead>
            <tr className="border-b border-[#658d71] text-[#658d71] text-[8px] uppercase tracking-widest">
              <th className="px-3 py-1.5 text-left">Opponent</th>
              {['W', 'L', 'G', 'Win%', 'R/G', 'Run Diff'].map(h => <th key={h} className="px-2 py-1.5">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {opponents.map((o, i) => (
              <tr key={i} className="border-b border-[rgba(101,141,113,0.2)] last:border-0 hover:bg-[rgba(255,255,255,0.03)]">
                <td className="px-3 py-1.5 text-left">
                  <span className="text-[10px] font-black text-white uppercase tracking-wide">{o.abbr}</span>
                </td>
                <td className="px-2 py-1.5 text-[10px] font-bold text-[#a9c9b1] tabular-nums">{o.w}</td>
                <td className="px-2 py-1.5 text-[10px] font-bold text-[#c4333e] tabular-nums">{o.l}</td>
                <td className="px-2 py-1.5 text-[10px] font-bold text-[#658d71] tabular-nums">{o.games}</td>
                <td className="px-2 py-1.5 text-[10px] font-black tabular-nums" style={{ color: o.winPct >= 0.5 ? '#a9c9b1' : '#c4333e' }}>
                  {(o.winPct * 100).toFixed(0)}%
                </td>
                <td className="px-2 py-1.5 text-[10px] font-bold text-[#d8ceb3] tabular-nums">{o.rpg}</td>
                <td className="px-2 py-1.5 text-[10px] font-black tabular-nums" style={{ color: o.rd >= 0 ? '#a9c9b1' : '#c4333e' }}>
                  {o.rd > 0 ? `+${o.rd}` : o.rd}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AnalyticsOpponents;